import { useState } from "react"
import { TextInput } from 'carbon-components-react';
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toaster } from '../../helpers/toaster';

import Button from '../../components/Button/Button';
import { Container, InputContainer, TextInputContainer, PrimaryText, SecondaryText } from './Login';
import { resetPasswordConfirmAPI } from "../../api/resetPassword";

const ResetPasswordConfirm = () => {
  const [password1, setPassword1] = useState(null)
  const [password2, setPassword2] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { client } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const onSubmit = () => {
    if (!token) {
      toaster("Invalid or missing reset token", "error");
      return;
    }
    setIsProcessing(true);
    if (password1 !== password2) {
      toaster("Passwords do not match", "warning");
      setIsProcessing(false);
      return;
    }
    if (!password1 || password1.length < 8) {
      toaster("Password must be at least 8 characters", "warning");
      setIsProcessing(false);
      return;
    }
    if (/^\d+$/.test(password1)) {
      toaster("Password cannot be entirely numeric", "warning");
      setIsProcessing(false);
      return;
    }

    resetPasswordConfirmAPI(token, password1)
    .then(_ => {
      toaster("Password has been reset successfully", "success")
      navigate(`/${client}`);
    }).catch(e => {
      toaster("Password reset failed", "error")
    }).finally(() => {
      setIsProcessing(false);
    })
  };

  const onKeyEnter = (e) => {
    if(e.keyCode === 13) {
      onSubmit()
    }
  }

  return (
    <Container>
      <InputContainer
        onKeyDown={onKeyEnter}
      >
        <PrimaryText>Reset Password</PrimaryText>
        <SecondaryText>Enter your new password</SecondaryText>
        <p style={{ color: '#999', fontSize: '12px', textAlign: 'center', margin: '8px 0' }}>
          Password must be at least 8 characters and cannot be entirely numeric or too similar to your personal information.
        </p>
        <TextInputContainer
          style={{marginTop: '10px', display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
        >
          <TextInput.PasswordInput
            id="reset-password-1"
            labelText=""
            placeholder='Enter password'
            onChange={e => setPassword1(e.target.value)}
            style={{display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
          />
        </TextInputContainer>
        <TextInputContainer
          style={{marginTop: '10px', display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
        >
          <TextInput.PasswordInput
            id="reset-password-2"
            labelText=""
            placeholder='Confirm password'
            onChange={e => setPassword2(e.target.value)}
            style={{display: 'flex', justifyContent: 'center', 'alignItems': 'center'}}
          />
        </TextInputContainer>
        <Button
          style={{ width: "100%", marginTop:10 }}
          onClick={onSubmit} disabled={isProcessing}>
          Set Password
        </Button>
      </InputContainer>
    </Container>
  )
}


export default ResetPasswordConfirm;
